// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 725 ? "react-syntax-highlighter/refractor-import" : chunkId) + "." + {"488":"7e9131fc","725":"73a06d23"}[chunkId] + ".chunk.js";
};